<template>
	<div class="LoadingAnimation">
		<CloIcon symbol="spinner" />
	</div>
</template>

<script>
import CloIcon from '@/icons/CloIcon/CloIcon';
export default {
	components: { CloIcon },
	data() {
		return {};
	},
};
</script>

<style lang="scss">
@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}

.LoadingAnimation {
	position: absolute;
	background-color: $color-white;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	padding: 0;
	&--inLightbox {
		background-color: transparent;
		.Icon {
			margin: -18px auto 0;
			@include centerCenter;
			fill: $color-neutral-3;
		}
	}
	&--modal {
		@include centerCenter;
		right: auto;
		[dir='rtl'] & {
			left: auto;
			right: 0;
		}
		bottom: auto;
		@include inset-md;
		border-radius: 0.25rem;
		transition: opacity 1s ease-out;
		.Icon {
			margin: 1rem auto !important;
		}
	}
	&--overlay {
		background-color: $color-overlay-white;
	}
	&--showMore {
		position: relative;
		background-color: transparent;
	}
	&--stacked {
		text-align: center;
		background-color: $color-overlay-white;
		padding: 1rem;
		z-index: 100;
		.Icon {
			margin-top: 10%;
			margin-bottom: 10%;
		}
	}
	.no-js & {
		display: none;
	}
	.Icon {
		display: block;
		@include icon-lg;
		fill: $color-secondary;
		margin: 2rem auto;
		animation-duration: 1.2s;
		animation-name: spin;
		animation-iteration-count: infinite;
		animation-timing-function: linear;
	}
	&--small {
		position: relative;
		display: inline;
		background-color: transparent;
		.Icon {
			@include icon-sm;
			display: inline;
			margin: 0;
		}
	}
	&--inTypeahead {
		background: none;
		right: 0.5rem;
		top: 0.5rem;
		bottom: auto;
		left: auto;
		[dir='rtl'] & {
			left: 0.5rem;
			right: auto;
		}
		.Icon {
			margin: 0;
			@include icon-md;
			//fill: $textColorMedium;
		}
	}
	&--basic {
		position: relative;
		background-color: transparent;
	}
}

.LoadingAnimation[aria-hidden='true'] {
	visibility: hidden;
}
</style>